import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import { AuthProvider } from './context/auth.context';
import { NotificationProvider } from './components/Notification/NotificationProvider';
import { ApiErrorToastBridge } from './components/ApiErrorToastBridge/ApiErrorToastBridge';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.StrictMode>
    <CookiesProvider defaultSetOptions={{ path: '/' }}>
      <BrowserRouter basename={process.env.PUBLIC_URL || ''}>
        <AuthProvider>
          <NotificationProvider>
            <ApiErrorToastBridge />
            <App />
          </NotificationProvider>
        </AuthProvider>
      </BrowserRouter>
    </CookiesProvider>
  </React.StrictMode>
);

reportWebVitals();
